import React from 'react';
import { Typography, Box, Chip, useTheme } from '@mui/material';
import { Check } from 'lucide-react';

interface PlanDescriptionProps {
  name?: string;
  interval?: string;
  amount?: string;
  duration?: string;
  trailDaysRemaining?: number;
  isTrialActive?: boolean;
}

const PlanDescription: React.FC<PlanDescriptionProps> = ({
  name = '',
  interval,
  amount,
  duration,
  trailDaysRemaining,
  isTrialActive,
}) => {
  const theme = useTheme();
  const lowerName = name.toLowerCase();
  console.log('PlanDescription rendered with name:', trailDaysRemaining);

  const getDescriptionList = () => {
    if (lowerName.includes('basic')) {
      return [
        'Knowledge Base',
        'Chat history',
        'Email support',
        'Single user',
        'Standard response time',
      ];
    }

    if (lowerName.includes('standard')) {
      return [
        'Basic plan features +',
        'Customer, resources and Service handlers',
        'Calendar Management',
        'Booking services',
      ];
    }

    return ['Basic plan features +', 'Standard plan features +', 'Custom features'];
  };

  return (
    <Box sx={{ flex: 1 }}>
      <Typography variant="h4" sx={{ mr: 2 }} component="div">
        {name}
        {isTrialActive && (
          <Chip
            size="small"
            label={'Free trial ends in ' + trailDaysRemaining + ' days'}
            sx={{ ml: 1, color: theme.palette.warning.main }}
          />
        )}
      </Typography>
      <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
        {amount}
        <Typography component="span" variant="body1" color="text.secondary" sx={{ ml: 1 }}>
          / {duration}
        </Typography>
      </Typography>

      <Box sx={{ my: 2 }}>
        {getDescriptionList().map((item, idx) => (
          <Typography variant="body2" color="text.secondary" key={idx}>
            • {item}
          </Typography>
        ))}
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip
          variant="outlined"
          size="small"
          label={`Billed ${interval || 'month'}ly`}
          icon={<Check size={14} />}
          sx={{ pl: 1 }}
        />
        <Chip
          sx={{ pl: 1 }}
          variant="outlined"
          size="small"
          label="Cancel anytime"
          icon={<Check size={14} />}
        />
      </Box>
    </Box>
  );
};

export default PlanDescription;
